import {required } from "@vuelidate/validators";
const ODuyuru = {
    data() {
      return { 
        ODuyuruData:{  
          Baslik:"",
          Icerik:"",
          IslemTarihi:"", 
          KayitTarihi:"",  
          YeniMi:false,  
          KimeGorunur:"", 
          KaydedenPersonelId:"3fa85f64-5717-4562-b3fc-2c963f66afa6",  
          Deleted:false,
        },  
          FormDataType:{
            Baslik:{FieldName:"Baslik",Field:"input",FieldTitle:"Başlık",FieldType:"text"},
            Icerik:{FieldName:"Icerik",Field:"textarea",FieldTitle:"İçerik"},
            IslemTarihi:{FieldName:"IslemTarihi",Field:"date",FieldTitle:"İşlem Tarihi"}, 
            YeniMi:{FieldName:"YeniMi",Field:"checkbox",FieldTitle:"Yeni Mi?"}  
          }  
      } 
    },
    validations:{ 
      FormData: {
          Baslik: { required },  
          Icerik: { required }, 
          IslemTarihi: { required }, 
          YeniMi: { required },  
      } 
  },
}
export default ODuyuru